import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Feb 20",
    Positive: 5,
    Nuetural: 2,
    Negative: 11,
  },
  {
    name: "Feb 21",
    Positive: 20,
    Nuetural: 5,
    Negative: 11,
  },
  {
    name: "Feb 22",
    Positive: 12,
    Nuetural: 9,
    Negative: 5,
  },
  {
    name: "Feb 23",
    Positive: 12,
    Nuetural: 6,
    Negative: 2,
  },
  {
    name: "Feb 24",
    Positive: 14,
    Nuetural: 6,
    Negative: 3,
  },
  {
    name: "Feb 25",
    Positive: 22,
    Nuetural: 2,
    Negative: 11,
  },
  {
    name: "Feb 26",
    Positive: 3,
    Nuetural: 8,
    Negative: 21,
  },
  {
    name: "Feb 27",
    Positive: 12,
    Nuetural: 5,
    Negative: 8,
  },
  {
    name: "Feb 28",
    Positive: 24,
    Nuetural: 8,
    Negative: 0,
  },
];

// let count = 0;
// for (let i = 0; i < data.length; i++) {
//   count += data[i].Negative;
// }
// console.log(count);

const EmotionGraph = () => {
  return (
    <div
      className="bg-white rounded-md shadow-sm mx-5 h-64 pt-6 pb-2 pr-5"
      style={{ width: "100%" }}
    >
      {/* <p className="p-0 m-0 text-gray-600 pl-8 font-bold">Sentiment Analysis</p> */}
      <div className="w-full h-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Positive" stroke="#34D399" />
            <Line type="monotone" dataKey="Nuetural" stroke="#60A5FA" />
            <Line type="monotone" dataKey="Negative" stroke="#F87171" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EmotionGraph;
